<style lang="scss">
  @import '../resources/scss/site_map';
</style>

<script lang="ts">
  import { locale } from 'svelte-i18n'
  import { fallbackLocale } from '../services/i18n'
  import { menusTrans } from '../stores/stores'
  import { Slugs } from '../config/slugs'
  import { listMenus } from '../controllers/AppController'
  import type Menu from '../api/rest/directus-cms/menus/model/Menu'
  import GrowingFamily from '../components/Growing_Family.svelte'
  import LibraryPlatform from '../components/Library_Platform.svelte'
  import Partners from '../components/Partners.svelte'
  import SubscribeNewsletter from '../components/Subscribe_Newsletter.svelte'

  let lang = $locale ?? fallbackLocale

  $: lang = $locale ?? fallbackLocale

  let menu_sitemap: Menu | undefined

  void listMenus(lang).then(
    () => (menu_sitemap = $menusTrans.find(m => m.slug === Slugs.SITE_MAP))
  )
</script>

{#if $menusTrans}
  <div class="container-xxl py-section">
    {#if menu_sitemap}
      <div class="row pb-5">
        <div class="col-12 text-start">
          <h1 class="h1 mb-3 text-neutral-a">{menu_sitemap.translations?.[0].name}</h1>
        </div>
      </div>
    {/if}
    <div class="row site-map-container">
      {#each $menusTrans as $menuItem}
        {#if $menuItem.show_sitemap}
          {#if $menuItem.submenus.length != 0}
            <div class="col-6 col-md-4 col-xl-3 px-4 pb-5">
              <a
                href={$menuItem.translations?.[0].link}
                class="h4 d-block mb-4 text-neutral-b"
              >
                {$menuItem.translations?.[0].name}
              </a>
              <div>
                {#each $menuItem.submenus as submenu}
                  <a
                    href={submenu.translations?.[0].link}
                    class="d-block mb-3 text-neutral-c"
                  >
                    {submenu.translations?.[0].name}
                  </a>
                {/each}
              </div>
            </div>
          {/if}
          {#if $menuItem.parent == undefined && $menuItem.submenus.length == 0}
            <div class="col-6 col-md-4 col-xl-3 px-4 pb-5">
              <a
                href={$menuItem.translations?.[0].link}
                class="h4 d-block mb-3 text-neutral-b"
              >
                {$menuItem.translations?.[0].name}
              </a>
            </div>
          {/if}
        {/if}
      {/each}
    </div>
  </div>
{/if}
<LibraryPlatform />
<GrowingFamily />
<SubscribeNewsletter />
<Partners />
